<div class="modal-header">
    <h3 class="modal-title" id="staticBackdropLabel">Detalle Solicitud</h3>
    <!--<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>-->
    <fa-icon [icon]="['fas', 'times']" (click)="onCloseModalR()" [size]="'lg'"></fa-icon>
</div>

<div class="modal-body">
    <form class="row g-3" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group col-3">
            <label for="nroSol">Nro. Solicitud</label>
            <input type="text" id="nroSol" formControlName="nroSol" class="form-control">
            <!--<div *ngIf="form.get('nombre').hasError('required')" class="error-message">
            El nombre es obligatorio.
            </div>-->
        </div>
        <div class="form-group col-9">
            <label for="creationDate">Fecha Creación</label>
            <input type="text" id="creationDate" formControlName="creationDate" class="form-control"> 
            <!--<div *ngIf="form.get('email').hasError('required')" class="error-message">
            El correo electrónico es obligatorio.
            </div>
            <div *ngIf="form.get('email').hasError('email')" class="error-message">
            Ingresa un correo electrónico válido.
            </div>-->
        </div>
        <div class="form-group col-4">
            <label for="rutEmpr">Rut Empresa</label>
            <input type="text" id="rutEmpr" formControlName="rutEmpr" class="form-control">
        </div>
        <div class="form-group col-8">
            <label for="razonSocial">Razón Social</label>
            <input type="text" id="razonSocial" formControlName="razonSocial" class="form-control">
        </div>
        <div class="form-group col-4">
            <label for="rutRep">Rut Representante</label>
            <input type="text" id="rutRep" formControlName="rutRep" class="form-control">
        </div>
        <div class="form-group col-8">
            <label for="nombreRep">Nombre Representante</label>
            <input type="text" id="nombreRep" formControlName="nombreRep" class="form-control">
        </div>
        <div class="form-group col-12">
            <label for="correoRep">Correo Representante</label>
            <input type="text" id="correoRep" formControlName="correoRep" class="form-control">
        </div>
        <span class="border-bottom"></span>
        <div class="form-group">
            <label for="motivo" class="form-label">Motivo Rechazo</label>
            <select class="form-select" aria-label="Default select example" id="motivo" formControlName="motivo">
                <option disabled selected="true">Selecciona motivo de rechazo</option>
                <option *ngFor="let motivos of motivosLov" [value]="motivos.code">{{ motivos.code_desc }}</option>
            </select>
        </div>
        <button type="submit" class="btn btn-primary" style="background-color: #dc3545;">Rechazar</button>
    </form>
</div>